// extracted by mini-css-extract-plugin
export default {"root":"CheckBoxField_root__EZ+m4"};